exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  font-size: 5rem; }\n\n.allcenter {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: calc(100vh - 177px);\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  width: 100%; }\n  .allcenter .btn.btn-blue {\n    border: none;\n    background: #572f76;\n    color: #ffffff;\n    border-radius: 30px;\n    padding: 15px 35px;\n    margin: 20px;\n    cursor: pointer;\n    text-transform: uppercase;\n    font-size: 14px; }\n\n@media screen and (max-width: 480px) {\n  .allcenter {\n    height: auto; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/not-found/not-found.component.scss
// module id = ../../../../../src/app/components/not-found/not-found.component.scss
// module chunks = main